// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementsAlertsList_wrapper__SPK4T","hidden":"AgreementsAlertsList_hidden__pyECY"};